import React, {useMemo} from 'react';
import {useParams} from 'react-router-dom';
import {studlyCase} from '@src/helpers/string-registres';
import str_plural from '@src/helpers/str_plural';
import ViewRepresentation from '@src/components/ViewRepresentation/ViewRepresentation';
import ImportView from '@src/components/_views/configurable/import-view/ImportView';

export default function ImportViewNavigator(props: { controllerName: string } & Record<any, any>) {
    const {model} = useParams<{ model: string }>();
    const newProps = useMemo(() => {
        return !model ? props : {
            ...props,
            controllerName: studlyCase(str_plural(model)),
        };
    }, [model, props]);

    return <ViewRepresentation element={ImportView} viewProps={newProps}/>;
}
